import {bindable, computedFrom} from 'aurelia-framework';
import {noop} from 'lodash';

export class GroupReportItemCustomElement {

  @bindable selectedItem = null;
  @bindable onSelect = noop;
  @bindable report: any = {};

  @computedFrom('selectedItem')
  get imageUrl() {
    return this.selectedItem === this.report
      ? this.report.iconSelUrl : this.report.iconUrl;
  }

  select() {
    this.onSelect({
      report: this.report
    });
  }

}
